import SomethingWentWrong from "../pages/SomethingWentWrong";
import { Component } from "react";

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			error: "",
			errorInfo: "",
		};
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		// logErrorToMyService(error, errorInfo);
		// console.log("ERROR", error, errorInfo)
		this.setState({ error, errorInfo, hasError: true });
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<SomethingWentWrong
					errorTitle={this.state.error}
					errorMessage={this.state.errorInfo}
					resetState={() =>
						this.setState({
							hasError: false,
							error: "",
							errorInfo: "",
						})
					}
				/>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
